<template>
    <div class="more_options">
        <div class="multiple_choice">
            <div class="option_title">
                <img v-if="is_required" style="width:18px;height:18px" src="../image/required.png">
                {{title}} (多选)
                <!-- {{index + 1}}. {{title}} (多选) -->
                <van-image
                  width="100%"
                  height="100%"
                  style="margin-top: 10px;"
                  v-if="img_url !== ''"
                  :src="img_url"
                />
                <div class="desc">
                  {{desc}}
                </div>
            </div>
            <van-checkbox-group v-model="selectData" :disabled = is_done>
                <van-cell-group class="box">
                    <van-cell
                        v-for="(item, index) in options"
                        clickable
                        :key="item.option_id"
                        :title="item.title"
                        @click="toggle(index)"
                        class="option_detail"
                        :class="selectData.includes(item) ? 'selectedClass' : ''"
                    >
                        <template #icon>
                            <van-checkbox class="option_icon" checked-color="#fe6900" shape="square" :name="item" ref="checkboxes" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      selectData: [],
      isWrite: false,
      questionData: {
        question_id: this.question_id,
        is_required: this.is_required,
        topic_id: this.topic_id,
        title: this.title,
        img_url: '',
        desc: '',
        options: this.options
      }
    }
  },
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    index: {
      type: Number
    },
    is_required: {
      type: Boolean
    },
    topic_id: {
      type: Number
    },
    question_id: {
      type: Number
    },
    is_done: {
      type: Boolean
    },
    desc: {
      type: String
    },
    img_url: {
      type: String
    },
    jump_rules: {
      type: Object
    }
  },
  mounted () {
    this.selectData = []
    this.isMakeOut()
    this.isSequired()
  },
  activated () {
    this.selectData = []
    this.isMakeOut()
    this.isSequired()
  },
  methods: {
    disposeQuestionID () {
      const OBJ = {}
      OBJ[this.question_id] = []
      const jumpRules = { ...this.jump_rules }
      if (JSON.stringify(jumpRules) !== '{}') {
        for (const key in jumpRules) {
          jumpRules[key].forEach(item => {
            // arr.push(item.next_question_id)
            // OBJ[questionId].push(item.next_question_id)
            this.questionData.options.forEach(item1 => {
              if (item1.answer) {
                // OBJ[this.question_id].push(item.option_id)
                if (+item1.option_id === +key) {
                  OBJ[this.question_id].push(item.next_question_id)
                }
              }
            })
          })
        }
      }
      // this.questionData.options.forEach(item => {
      //   if (item.answer) {
      //     OBJ[this.question_id].push(item.option_id)
      //   }
      // })
      this.$emit('UpskipQuestionId', OBJ)
    },
    isMakeOut () {
      if (this.is_done) {
        for (let i = 0; i < this.options.length; i++) {
          const item = this.options[i]
          if (item.answer) {
            this.selectData.push(item)
          }
        }
      } else {
        this.selectData = []
      }
    },
    toggle (index) {
      if (this.is_done) return // 如果用户填写过数据跳过执行函数
      this.$refs.checkboxes[index].toggle()
      //   (this.selectData.indexOf(this.list[index]) > -1) ? this.selectData.splice(this.selectData.indexOf(this.list[index]), 1) : this.selectData.push(this.list[index])
    },
    // 判断问卷是否为必填项
    isSequired () {
      if (!this.is_required) {
        this.isWrite = true
      } else {
        this.isWrite = false
      }
    }
  },
  watch: {
    selectData (val) {
      // if (this.is_done) return // 如果用户填写过数据跳过执行函数
      const val1 = JSON.parse(JSON.stringify(val))
      val1.forEach(item => {
        item.answer = true
      })
      const arr = JSON.parse(JSON.stringify(this.questionData.options))
      for (let i = 0; i < arr.length; i++) {
        const item1 = JSON.parse(JSON.stringify(arr[i]))
        for (let j = 0; j < val1.length; j++) {
          const item2 = val1[j]
          if (item1.option_id === item2.option_id) {
            arr[i] = JSON.parse(JSON.stringify(item2))
            break
          } else {
            arr[i].answer = false
          }
        }
      }
      arr.forEach(item => {
        if (item.answer === '' || this.selectData.length <= 0) {
          item.answer = false
        }
      })
      this.questionData.options = arr
      this.disposeQuestionID()
      // 以下用于判断是否填写该问卷
      if (this.selectData.length > 0) {
        this.isWrite = true
      } else {
        this.isSequired()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.multiple_choice{
    .option_title{
        margin-bottom: 15px;
        .desc{
          font-size: 13px;
          color: dimgray;
        }
    }
    .img-icon{
        height: 20px;
        margin-right: 10px;
    }
    .option_detail{
        border: 1px solid rgb(184, 177, 177);
        border-collapse: collapse;
    }
    .option_detail:not(:nth-child(1)){
        border-top: none;
    }
    .selectedClass{
        border: 1px solid #ffdbc1;
        background-color: #fff7f2;
    }
    .option_icon{
        margin-right: 10px;
    }
}
</style>
